<br />
<form class="form">
    <fieldset>
        <div>
            <kendo-grid [data]="responseData" [pageable]="false" [sortable]="true" [filterable]="false" [height]="625" [resizable]="true">
                <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                        {{rowIndex+1}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Menu Id" field="menuId" hidden="true"></kendo-grid-column>
                <kendo-grid-column title="Parent Menu Id" field="parentMenuId" hidden="true"></kendo-grid-column>
                <kendo-grid-column title="Menu Name" field="displayName">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.displayName}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.displayName}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Menu Icon" field="icon">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.icon}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.icon}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Menu URI" field="routeUrl">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.routeUrl}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.routeUrl}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Menu Order" field="menuOrder">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.menuOrder}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.menuOrder}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Is Active" field="isActive">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                        <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.isActive" [disabled]="true"></kendo-switch>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Admin Menu" field="isAdminMenu">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                        <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.isAdminMenu" [disabled]="true"></kendo-switch>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Project Code Required" field="isProjectCodeRequired">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                        <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.isProjectCodeRequired" [disabled]="true"></kendo-switch>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-command-column title="Action" width="100">
                    <ng-template kendoGridHeaderTemplate let-dataItem="dataItem">
                        Action
                        <div class="iconPosition">
                            <i class="fa fa-plus-circle" (click)="onClick_manageMenu(dataItem, parentMenuId, true)" matTooltip="Add parent menu" aria-hidden="true" style="cursor: pointer;">
                            </i>
                        </div>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <i class="fa fa-pencil eip-link" style="font-size: 1.25em; cursor: pointer;" title="Edit" (click)="onClick_manageMenu(dataItem, parentMenuId, true)" aria-hidden="true"></i>
                    </ng-template>
                </kendo-grid-command-column>
                <div *kendoGridDetailTemplate="let dataItem">
                    <div class="col-md-4 col-lg-4 col-xs-12 mb-sm-10" style="margin-left: -13px;">
                        <div class="row">
                            <div class="col-md-5 col-lg-6 col-sm-5 col-xs-6">
                                <button class="btn btn-primary " id="positionbtn" title="Add Child Menu" (click)="onClick_manageMenu(null, dataItem.menuId, false)"><i class="fa fa-plus-circle" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Add Child Menu</button>
                            </div>
                        </div>
                    </div>
                    <kendo-grid [data]="dataItem.subMenu" [pageable]="false" [sortable]="false" [resizable]="true" [filterable]="false">
                        <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                {{rowIndex+1}}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Menu Id" field="menuId" hidden="true"></kendo-grid-column>
                        <kendo-grid-column title="Parent Menu Id" field="parentMenuId" hidden="true"></kendo-grid-column>
                        <kendo-grid-column title="Menu Name" field="displayName">
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                                <span class="no-wrap" eipTooltip="{{dataItem.displayName}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.displayName}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Menu Icon" field="icon">
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                                <span class="no-wrap" eipTooltip="{{dataItem.icon}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.icon}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Menu URI" field="routeUrl">
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                                <span class="no-wrap" eipTooltip="{{dataItem.routeUrl}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.routeUrl}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Menu Order" field="menuOrder">
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                                <span class="no-wrap" eipTooltip="{{dataItem.menuOrder}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.menuOrder}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Is Active" field="isActive">
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.isActive" [disabled]="true" [size]="small"></kendo-switch>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Admin Menu" field="isAdminMenu">
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.isAdminMenu" [disabled]="true" [size]="small"></kendo-switch>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Project Code Required" field="isProjectCodeRequired">
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.isProjectCodeRequired" [disabled]="true" [size]="small"></kendo-switch>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-command-column title="Action" width="100">
                            <!-- <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                    Action
                    <div class="iconPosition">
                      <i class="fa fa-plus-circle" (click)="onClick_manageMenu(column, column.menuId, false)"
                        matTooltip="Add child menu" aria-hidden="true" style="cursor: pointer;">
                      </i>
                    </div>
                  </ng-template> -->
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                                <i class="fa fa-pencil eip-link" title="Edit" (click)="onClick_manageMenu(dataItem, dataItem.parentMenuId, false)" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                            </ng-template>
                        </kendo-grid-command-column>
                    </kendo-grid>
                </div>
            </kendo-grid>
        </div>
    </fieldset>
</form>